import { motion } from "framer-motion";
import React, { useContext } from "react";
import AboutHome from "../components/About/AboutHome";
import AmbitionsHome from "../components/About/AmbitionsHome";
import TopHome from "../components/About/TopHome";

import SkillHome from "../components/Skill/SkillHome";

import DemoHome from "../components/Demo/DemoHome";
import ExperimentsHome from "../components/Experiments/ExperimentsHome";
import Footer from "../components/Footer/Footer";
import LoadingHome from "../components/Loading/LoadingHome";
import ContentMain from "../components/Main/ContentMain";
import Main from "../components/Main/Main";
import ProjectHome from "../components/Project/ProjectHome";

import LowpolyHero from "../components/Three/LowpolyHero";
import { Context } from "../context";

const Home = (props) => {
  const { debug, lang } = useContext(Context);

  return (
    <>
      <title>Davide Balice - Full stack web developer</title>
      <LoadingHome />
      <motion.div
        initial={{ opacity: 0.6, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0.6 }}
        transition={{ duration: 0.4, delay: 1 }}
      >
        <Main>
          <ContentMain>
            <LowpolyHero />
            <TopHome />





            <AboutHome />
            <ExperimentsHome />
            <SkillHome />
            <AmbitionsHome />
            <DemoHome />
            <Footer />
          </ContentMain>
        </Main>
      </motion.div>
    </>
  );
};

export default Home;
